// HotjarLoader.js
'use strict';
import { connect } from 'react-redux';

import {
  HOTJAR_SITE_ID,
  HOTJAR_VERSION,
  ENABLE_HOTJAR,
} from '../RemoteConfigKeys.js';

import getRemoteConfigData from '../selector/getRemoteConfigData.js';

import HotjarLoader from '../component/HotjarLoader.jsx';

const mapStateToProps = state => {
  return {
    hotjarSiteId: getRemoteConfigData(state, HOTJAR_SITE_ID),
    hotjarVersion: getRemoteConfigData(state, HOTJAR_VERSION),
    enableHotjar: getRemoteConfigData(state, ENABLE_HOTJAR) === 1,
  };
};

export default connect(mapStateToProps)(HotjarLoader);
